import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/rejectReview`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/rejectReview`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/rejectReview`;
